<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" id="chart">
        <h1>{{ naming }}</h1>
        <apexchart
          v-if="chartOptions"
          ref="customerChart"
          type="pie"
          height="380"
          :options="chartOptions"
          :series="series"
        />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="500"
      >
        <v-card class="border">
          <v-card-title class="text-h5">Statistics</v-card-title>
          <v-card-text>
            Element that you clicked: {{ chartDialog }}
          </v-card-text>
          <v-row>
            <v-col cols="12" lg="12" md="12">
              <Bar />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="teal" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Bar from "../components/Bar.vue";
import axios from "axios";
import { isAuthError } from "../helpers/apiAuth";

export default {
  components: {
    Bar,
  },
  props: {
    naming: String,
  },
  data() {
    return {
      dialog: false,
      chartDialog: 0,
      series: [0, 0],
    };
  },
  mounted() {
    this.getAvailableCustomers();
  },
  methods: {
    async getAvailableCustomers() {
      try {
        const response = await axios.post(
          this.$apiUrl,
          {
            query: `query {
              userCardsAssigned {
                ALL
                ASSIGNED
                NOTASSIGNED
              }
            }`,
          },
          {
            headers: {
              Authorization: "Bearer " + (await this.$auth.getAccessToken()),
            },
          }
        );

        const res = response.data.data.userCardsAssigned;
        this.series = [res.ASSIGNED || 0, res.NOTASSIGNED || 0];

        // update chart explicitly if needed
        this.$nextTick(() => {
          if (this.$refs.chart) {
            this.$refs.chart.updateSeries(this.series);
          }
        });
      } catch (error) {
        if (isAuthError(error)) {
          this.$apiAuthenticated = false;
        }
        console.error("Failed to load assigned data:", error);
      }
    },

    onDataPointSelected(event, chartContext, config) {
      const sum = config.w.globals.series.reduce((acc, val) => acc + val, 0);
      const value = config.w.globals.series[config.dataPointIndex];
      const percent = ((value / sum) * 100).toFixed(2);

      this.chartDialog = `${percent}% (${value})`;
      this.dialog = true;
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "pie",
          events: {
            dataPointSelection: this.onDataPointSelected,
          },
        },
        legend: {
          formatter: (val, opts) => {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
          labels: {
            useSeriesColors: true,
          },
          position: "bottom",
        },
        labels: ["Assigned", "Not Assigned"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 320,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #009688;
}
</style>